import { createAction } from 'redux-actions';

import { SET_DATA_TYPES, IS_LOADING } from '../reducers/dataTypes';
import { getDataTypes as getStorageDataTypes } from '../../firebase/storage';

const setDataTypes = createAction(SET_DATA_TYPES);
const setLoading = createAction(IS_LOADING);

export const getDataTypes = () => async dispatch => {
    dispatch(setLoading(true));

    try {
        const dataTypes = await getStorageDataTypes();

        dispatch(setDataTypes({ dataTypes }));
    } finally {
        dispatch(setLoading(false));
    }
}



// WEBPACK FOOTER //
// ./src/store/actions/dataTypes.js